import { useMountEffect } from '@/shared/hooks/useMountEffect';
import {
  StepperPageTemplate,
  BrandGoalStep,
  AudienceStep,
  CompetitorsStep,
  useAnalysisFormStore,
  useCreateAnalysis,
  buildCreateAnalysisPayload,
} from '@/features/analysis';
import { usePersonas } from '@/entities/persona';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { useTranslation } from 'react-i18next';

export function NewAnalysis() {
  const { t } = useTranslation('analysis');

  const createAnalysis = useCreateAnalysis();
  const workspaceId = useCurrentWorkspaceId();
  // Lifted from `features/analysis` per Springboard dependency injection: the page owns
  // cross-feature reads, the analysis stepper accepts data via props.
  const { data: personas = [], isPending: personasPending } = usePersonas(workspaceId);

  useMountEffect(() => {
    useAnalysisFormStore.getState().reset();
    return undefined;
  });

  const handleSubmit = () => {
    const payload = buildCreateAnalysisPayload();
    createAnalysis.mutate(payload);
  };

  return (
    <StepperPageTemplate
      title={t('newAnalysis.newIqAnalysis')}
      stepLabels={[
        t('newAnalysis.brandGoal'),
        t('newAnalysis.audience'),
        t('newAnalysis.competitors'),
      ]}
      steps={[
        ({ onValidChange }) => <BrandGoalStep onValidChange={onValidChange} />,
        ({ onValidChange }) => (
          <AudienceStep
            personas={personas}
            isPending={personasPending}
            onValidChange={onValidChange}
          />
        ),
        ({ onValidChange }) => <CompetitorsStep onValidChange={onValidChange} />,
      ]}
      onSubmit={handleSubmit}
      isSubmitting={createAnalysis.isPending}
    />
  );
}
